/************************************************
 * Created By nanyuantingfeng On 6/13/16 15:19.
 ************************************************/
export const ID = '@common'
export default {
  ID
}
